module.exports = __webpack_public_path__ + "static/img/jiayoubanner.6013ab0.png";


//////////////////
// WEBPACK FOOTER
// ./static/jiayoubanner.png
// module id = wuOH
// module chunks = 1